import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MapLoaderService } from '@shared/services/map-loader.service';
import { EGoogleLib } from '@shared/models/configurations.interface';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

export const mapLoaderResolver: ResolveFn<boolean> = () => {
  return inject(MapLoaderService)
    .loadMaps()
    .pipe(
      map(() => true),
      catchError(() => of(false))
    );
};

export const mapLibraryResolver = (
  libraryName: EGoogleLib
): ResolveFn<boolean> => {
  return async () => {
    if (typeof google !== 'undefined' && google.maps) {
      try {
        await google.maps.importLibrary(libraryName);
        return true;
      } catch (error) {
        console.error('Failed to Load Google Library: ', error);
      }
    }
    return false;
  };
};
